import { createContext, useContext, useEffect, useState, type ReactNode } from "react";

type Tema = "oscuro" | "claro";
const CLAVE = "zociety:tema";

const Ctx = createContext<{ tema: Tema; alternar: () => void } | null>(null);

export function TemaProvider({ children }: { children: ReactNode }) {
  const [tema, setTema] = useState<Tema>(() => {
    const guardado = localStorage.getItem(CLAVE);
    if (guardado === "claro" || guardado === "oscuro") return guardado;
    // La marca es de modo oscuro; solo se respeta la preferencia explícita
    // del sistema cuando pide claro.
    return window.matchMedia?.("(prefers-color-scheme: light)").matches ? "claro" : "oscuro";
  });

  useEffect(() => {
    document.documentElement.dataset.tema = tema;
    localStorage.setItem(CLAVE, tema);
  }, [tema]);

  return (
    <Ctx.Provider value={{ tema, alternar: () => setTema((t) => (t === "oscuro" ? "claro" : "oscuro")) }}>
      {children}
    </Ctx.Provider>
  );
}

export function useTema() {
  const ctx = useContext(Ctx);
  if (!ctx) throw new Error("useTema debe usarse dentro de TemaProvider");
  return ctx;
}
